import React from "react";
import { formatCurrency } from "../../../utils/formatters";

function amount(value, currency) {
  const numeric = Number(value || 0);
  try {
    const formatted = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "USD",
    }).format(Math.abs(numeric));
    return numeric < 0 ? `(${formatted})` : formatted;
  } catch {
    return formatCurrency(numeric);
  }
}

export default function ClientReportTable({ columns = [], rows = [], currency = "USD", emptyLabel }) {
  if (!rows.length) {
    return (
      <div className="py-12 text-center text-sm text-slate-500">
        {emptyLabel || "No report rows are available for this period."}
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border-collapse text-sm">
        <thead>
          <tr className="border-b-2 border-slate-800 text-left">
            {columns.map((column) => (
              <th key={column.key} className={`px-3 py-3 text-[10px] font-bold uppercase tracking-wider text-slate-500 ${column.numeric ? "text-right" : ""}`}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.key || `${row.label}-${index}`} className={`border-b border-slate-100 ${row.kind === "total" ? "bg-slate-50 font-bold text-slate-900" : row.kind === "grand" ? "border-t-2 border-slate-800 bg-slate-50 font-black text-slate-900" : "text-slate-700"}`}>
              {columns.map((column) => {
                const value = row[column.key];
                return (
                  <td key={column.key} className={`px-3 py-3 ${column.numeric ? "text-right tabular-nums" : ""} ${row.kind === "section" ? "font-bold text-slate-900" : ""}`}>
                    {column.numeric ? amount(value, currency) : (
                      <span style={{ paddingLeft: column.key === "label" ? `${(row.level || 0) * 16}px` : undefined }}>
                        {value ?? ""}
                      </span>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}